"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGettextExpression = exports.isGettextExpression = void 0;
const types_1 = require("./types");
const RE_PATTERN_GETTEXT = /^_\(\"([\w\d \.\,\_\|\-%$\/\(\)']+)\"\)$/, RE_PATTERN_PGETTEXT = /^P_\(\"([\w\d \.\,\_\|\-%$\/\(\)]+)\" *, *\"([\w\d \.\:\,\_\|\-%$\/\(\)']+)\"\)$/, RE_PATTERN_NGETTEXT = /^N_\(\"([\w\d \.\,\_\|\-%$\/\(\)']+)\" *, *\"([\w\d \.\:\,\_\|\-%$\/\(\)']+)\" *, *([\w\d\[\]\.\_\|%$\/]+)\)$/;
function isGettextExpression(expression) {
    expression = expression.trim();
    return (RE_PATTERN_GETTEXT.test(expression) ||
        RE_PATTERN_PGETTEXT.test(expression) ||
        RE_PATTERN_NGETTEXT.test(expression));
}
exports.isGettextExpression = isGettextExpression;
function parseGettextExpression(expression) {
    let match;
    while ((match = RE_PATTERN_GETTEXT.exec(expression)) !== null) {
        return {
            valid: true,
            kind: types_1.GettextKind.gettext,
            msgid: match[1],
        };
    }
    while ((match = RE_PATTERN_PGETTEXT.exec(expression)) !== null) {
        return {
            valid: true,
            kind: types_1.GettextKind.pgettext,
            context: match[1],
            msgid: match[2],
        };
    }
    while ((match = RE_PATTERN_NGETTEXT.exec(expression)) !== null) {
        return {
            valid: true,
            kind: types_1.GettextKind.ngettext,
            msgid: match[1],
            n: Number(match[2]),
        };
    }
    return {
        valid: false,
        kind: types_1.GettextKind.invalid,
        msgid: '',
    };
}
exports.parseGettextExpression = parseGettextExpression;
//# sourceMappingURL=parser.js.map